<template>
  <div class="disney">
    <div class="loading-page" v-if="loadingStatus == 0">
      <div class="loading-content" :style="styleList.loadingBgImg">
        <img class="loading-logo" :src="styleList.loadingBgLogo" />
      </div>
    </div>
    <div class="content-page" v-if="loadingStatus == 1">
      <div class="content-header" :style="styleList.contentHeader">
        <!-- header -->
        <button
          class="view-rule-btn"
          @click="handlePopup('activityRule')"
        ></button>
      </div>
      <div class="lottery-area">
        <!-- 抽奖区域 -->
        <template v-if="activityStatus < 3">
          <!-- 活动未开始 -->
          <div class="lottery-header" :style="styleList.lotteryHeader">
            <div class="header-content lottery-header-not-start">
              活动暂未开始，敬请期待！
            </div>
          </div>
        </template>
        <template v-if="activityStatus == 3">
          <!-- 活动进行中 -->
          <!-- 电量值 -->
          <div class="lottery-header" :style="styleList.lotteryHeader">
            <div class="header-content content-on">
              <div class="header-desc">{{ swiperOption.leftInput }}</div>
              <div class="remaining-energy">
                {{ remainingEnergy || 0 }}
                <i class="decorate"></i>
              </div>
              <div class="header-desc">{{ swiperOption.rightInput }}</div>
            </div>
          </div>
        </template>
        <template v-if="activityStatus > 3">
          <!-- 活动已结束 -->
          <div class="lottery-header" :style="styleList.lotteryHeader">
            <div class="header-content">活动已结束，谢谢参与！</div>
          </div>
        </template>
        <div class="lottery-content" :style="styleList.lotteryContent">
          <div class="lottery-list">
            <!-- 抽奖转盘 -->
            <fragment v-for="(item, index) in prizeList" :key="index">
              <img
                class="img"
                v-show="currentIndex == index"
                :class="'img' + (index + 1)"
                :src="item.columnBrightImage"
                alt
              />
            </fragment>
          </div>
          <img class="lottery-center" :src="styleList.lotteryCenter" alt />
          <div
            class="lottery-pirze-overview"
            @click="handlePopup('lotteryPrizeOverview')"
          >
            <div class="btn" :style="styleList.lotteryPrizeOverviewBtn"></div>
          </div>
        </div>
        <div class="lottery-footer" :style="styleList.lotteryFooter">
          <div class="lottery-btn" :style="styleList.lotteryBtn">
            <!-- 抽奖 -->
            <button
              class="btn"
              :disabled="btnDisabled"
              @click.stop="startLottery"
            ></button>
          </div>
          <div
            class="share-btn"
            :style="styleList.shareBtn"
            @click="shareActivity"
          ></div>
          <!-- 分享活动 -->
        </div>
      </div>
      <div class="collect-area">
        <!-- 集卡区域 -->
        <div class="collect-content" :style="styleList.collectContent">
          <div class="list">
            <div class="item" v-for="(item, index) in cardList" :key="index">
              <img
                class="item-img"
                v-if="item.holdCount"
                :src="item.cardHeadBrightImage"
              />
              <img class="item-img" v-else :src="item.cardHeadImage" />
            </div>
          </div>
          <div class="count">
            <!-- 印记数量 -->
            {{ winCardCount || 0 }}
          </div>
          <div
            class="prints-rule-overview"
            @click.stop="handlePopup('printsRuleOverview')"
          ></div>
          <button
            class="collect-btn"
            :disabled="isExchange"
            :style="collectBtnStyle"
            @click.stop="exchangeCollectPrize"
          ></button>
        </div>
      </div>
      <div class="reward-wrap" v-if="activityStatus > 2">
        <!-- 奖品区域 -->
        <div class="header">
          <img :src="awardOption.awardHeaderImg" alt />
        </div>
        <template v-if="composeRecordStatus">
          <div
            :class="
              composeRecordList.length <= 0 ? 'content' : 'content active'
            "
            :style="styleList.recordContent"
            ref="content"
            @scroll="handleRecordScroll"
          >
            <template v-if="composeRecordList.length <= 0">
              <img :src="awardOption.awardMiddleImg" alt />
            </template>
            <template v-else>
              <fragment v-for="(item, index) in composeRecordList" :key="index">
                <img
                  v-if="item.$recordType === 'lottery'"
                  :src="item.prizeImage"
                  @click="checkPrize(item)"
                  alt
                />
                <img
                  v-if="item.$recordType === 'collect'"
                  :src="styleList.awardImg"
                  @click="checkPrize(item)"
                  alt
                />
              </fragment>
            </template>
          </div>
        </template>
        <div class="footer">
          <img :src="awardOption.ruleBottomImg" alt />
        </div>
      </div>
      <div class="rule-wrap">
        <div class="header">
          <img :src="ruleOption.ruleHeaderImg" alt />
        </div>
        <div class="content">
          <div class="hot-area">
            <div
              v-for="(item, index) in 3"
              @click="changeRule(index)"
              :class="[currentRule == index ? 'current' : '', 'item' + index]"
              :current="currentRule"
              :key="item"
            ></div>
          </div>
          <img :src="ruleOption.ruleLeftImg" v-show="currentRule == 0" alt />
          <img :src="ruleOption.ruleMiddleImg" v-show="currentRule == 1" alt />
          <img :src="ruleOption.ruleRightImg" v-show="currentRule == 2" alt />
        </div>
        <div class="footer" @click="handleClick('rule')">
          <img :src="ruleOption.ruleBottomImg" alt />
        </div>
      </div>
      <div class="explore-area">
        <!-- 探索区域 将探索区域的图片拆分成多个-->
        <div
          v-for="(item, index) in exploreList"
          class="explore-item"
          :key="index"
        >
          <img class="explore-item-img" :src="item" alt="" />
        </div>
        <div class="explore-item explore-item-btn">
          <!-- 探索区域尾部 -->
          <img
            class="explore-item-img"
            :src="styleList.exploreItemBtn"
            alt=""
          />
          <button class="btn" @click="handleClick('redirect')"></button>
        </div>
      </div>
    </div>

    <Cmask :showMask="showMask">
      <div class="content-wrap" :class="modalEvent ? 'content-wrap-ab' : ''">
        <div class="guide-wrap" v-if="beFirst && modalType == 'guide'">
          <!-- 新用户引导图 -->
        </div>
        <div class="activity-rule-wrap" v-if="modalType == 'activityRule'">
          <!-- 活动规则 -->
          <img :src="styleList.activityRule" alt />
        </div>
        <div
          class="lottery-prize-overview-wrap"
          v-if="modalType == 'lotteryPrizeOverview'"
        >
          <img :src="styleList.lotteryPrizeOverview" alt />
        </div>
        <div class="prints-rule-wrap" v-if="modalType == 'printsRuleOverview'">
          <!-- 点亮印记规则 -->
          <img :src="styleList.printsRuleOverview" alt />
        </div>
        <div class="countError-wrap" v-if="modalType == 'countError'">
          <!-- 活动数值不足 -->
          <img :src="gridOption.countEnable" alt />
          <button
            class="btn"
            :style="styleList.useBattery"
            @click.stop="handleClick('countError')"
          ></button>
        </div>
        <div class="remind-wrap" v-if="modalType == 'remindCard'">
          <!-- 查看提醒的卡片 -->
          <img :src="currentRemindItem.cardImage" alt />
          <button class="btn" @click.stop="receiveCollectionCard"></button>
        </div>
        <div class="award-gif-wrap" v-if="gifType == 'awardGif'">
          <!-- 集卡的动画 -->
          <img class="gif" :src="gif" alt @load="awardGifLoad" />
        </div>
        <div
          class="award-wrap"
          :class="modalEvent ? 'award-wrap-ab' : ''"
          v-if="modalType == 'award'"
          :style="styleList.collectModalBg"
        >
          <!-- 集卡的奖品弹窗 --->
          <div class="form-list">
            <fragment :key="index" v-for="(item, index) in formList">
              <div v-if="item.paramName == 'name'" class="form-row">
                <div class="label-wrapper">
                  <img :src="lightIcon" class="form-icon" alt />
                  <label for class="form-label">收货人：</label>
                </div>
                <input
                  :disabled="submitInfoBtnStatus === 1"
                  maxlength="15"
                  class="form-input"
                  type="text"
                  :placeholder="item.tips"
                  v-model="submitInfo.name"
                />
              </div>
              <div v-else-if="item.paramName == 'phone'" class="form-row">
                <div class="label-wrapper">
                  <img :src="lightIcon" class="form-icon" alt />
                  <label for class="form-label">联系方式：</label>
                </div>
                <input
                  :disabled="submitInfoBtnStatus === 1"
                  maxlength="11"
                  class="form-input"
                  type="tel"
                  :placeholder="item.tips"
                  v-model="submitInfo.phone"
                />
              </div>
              <div v-else-if="item.paramName == 'address'" class="form-row">
                <div class="address-label label-wrapper">
                  <img :src="lightIcon" class="form-icon" alt />
                  <label :style="prizeFontStyle" for class="form-label"
                    >收件地址：</label
                  >
                </div>
                <textarea
                  :disabled="submitInfoBtnStatus === 1"
                  maxlength="500"
                  class="form-textarea"
                  rows="3"
                  :placeholder="item.tips"
                  v-model="submitInfo.address"
                ></textarea>
              </div>
            </fragment>
          </div>
          <img
            :src="styleList.submitActive"
            @click="addCollectAddress"
            v-if="submitInfoBtnStatus === 0"
            class="btn"
          />
          <img
            :src="styleList.submitInactive"
            v-if="submitInfoBtnStatus === 1"
            class="btn"
          />
        </div>
        <div class="prize-gif-wrap" v-if="gifType == 'prizeGif'">
          <!-- 抽奖的动画 -->
          <img class="gif" :src="gif" alt @load="prizeGifLoad" />
        </div>
        <div
          class="prize-wrap"
          :class="modalEvent ? 'prize-wrap-ab' : ''"
          :style="{ 'background-image': 'url(' + modelBgc + ')' }"
          @click="handleCopy"
          v-if="modalType == 'prize'"
        >
          <fragment v-if="lotteryPrize.prizeType == 0">
            <img
              :src="styleList.closeBtn"
              @click="handleClick('prize')"
              class="btn"
            />
          </fragment>
          <fragment v-else-if="lotteryPrize.prizeType == 1">
            <img
              :src="styleList.couponBtn"
              @click="handleClick('prize')"
              class="btn"
            />
          </fragment>
          <span
            v-else-if="lotteryPrize.prizeType == 2"
            class="ticket-code"
            :style="prizeFontStyle"
            >{{ ticketCode }}</span
          >
          <div v-else-if="lotteryPrize.prizeType == 3">
            <div class="form">
              <fragment :key="index" v-for="(item, index) in prizeFormItems">
                <div v-if="item.paramName == 'name'" class="form-row">
                  <div class="label-wrapper">
                    <img :src="lightIcon" class="form-icon" alt />
                    <label :style="prizeFontStyle" for class="form-label"
                      >收货人：</label
                    >
                  </div>
                  <input
                    :style="prizeBorderStyle"
                    :disabled="userInfoBtnStatus === 1"
                    maxlength="15"
                    class="form-input"
                    type="text"
                    :placeholder="item.tips"
                    v-model="userInfo.name"
                  />
                </div>
                <div v-else-if="item.paramName == 'phone'" class="form-row">
                  <div class="label-wrapper">
                    <img :src="lightIcon" class="form-icon" alt />
                    <label :style="prizeFontStyle" for class="form-label"
                      >联系方式：</label
                    >
                  </div>
                  <input
                    :style="prizeBorderStyle"
                    :disabled="userInfoBtnStatus === 1"
                    maxlength="11"
                    class="form-input"
                    type="tel"
                    :placeholder="item.tips"
                    v-model="userInfo.phone"
                  />
                </div>
                <div v-else-if="item.paramName == 'address'" class="form-row">
                  <div class="address-label label-wrapper">
                    <img :src="lightIcon" class="form-icon" alt />
                    <label :style="prizeFontStyle" for class="form-label"
                      >收件地址：</label
                    >
                  </div>
                  <textarea
                    :style="prizeBorderStyle"
                    :disabled="userInfoBtnStatus === 1"
                    maxlength="500"
                    class="form-textarea"
                    rows="3"
                    :placeholder="item.tips"
                    v-model="userInfo.address"
                  ></textarea>
                </div>
                <div v-else-if="item.paramName == 'remark'" class="form-row">
                  <label :style="prizeFontStyle" for class="form-label"
                    >备注：</label
                  >
                  <input
                    :style="prizeBorderStyle"
                    :disabled="userInfoBtnStatus === 1"
                    maxlength="500"
                    class="form-input"
                    type="text"
                    :placeholder="item.tips"
                    v-model="userInfo.remark"
                  />
                </div>
                <div v-else-if="item.paramName == 'other'" class="form-row">
                  <label :style="prizeFontStyle" for class="form-label"
                    >其他：</label
                  >
                  <textarea
                    :style="prizeBorderStyle"
                    :disabled="userInfoBtnStatus === 1"
                    maxlength="500"
                    class="form-textarea"
                    rows="3"
                    :placeholder="item.tips"
                    v-model="userInfo.other"
                  ></textarea>
                </div>
              </fragment>
            </div>
            <img
              :src="submitBtn"
              @click="addLotteryAddress"
              v-if="userInfoBtnStatus === 0"
              class="btn"
            />
            <img
              :src="submittedBtn"
              v-if="userInfoBtnStatus === 1"
              class="btn"
            />
          </div>
          <div
            class="prize-area"
            @click="handleClick('prize')"
            v-else-if="lotteryPrize.prizeType == 4"
          ></div>
        </div>
        <div class="line" v-if="!modalEvent">
          <span v-for="item in 7" :key="item" class="dotted-line"></span>
          <img
            class="close-icon"
            src="./../../../assets/imgs/close.png"
            @click="closeDialog"
            alt
          />
        </div>
      </div>
    </Cmask>

    <Cmask v-show="shareGuide">
      <!-- 分享引导图 -->
      <div class="share-guide" @click="hideShareGuide">
        <img class="share-guide-img" :src="styleList.shareGuide" alt />
      </div>
    </Cmask>

    <Cmask v-show="eleLoading">
      <!-- 抽奖loading -->
      <div class="eleLoadingContent">
        <img
          class="eleLoading"
          src="https://static.enmonster.com/1385169439842111488"
        />
      </div>
    </Cmask>
  </div>
</template>

<script>
/**
 *  NO_PRIZE(0,"谢谢参与"),
    ENMONSTER_COUPON(1,"怪兽充电券"),
    OUT_COUPON(2,"第三方券码"),
    ENTITY_PRIZE(3,"表单类奖品"),
    NOTICE_PRIZE(4,"告知类奖品"),
    COLLECT_CARD(5,"集卡卡片"),
    COLLECT_NO_CARD(6,"未中卡")
 */

import { isMiniApplets } from "@/utils/browser";

const requireImg = (url) =>
  `https://cdn.enmonster.com/activity/disneyanniv5/assets/${url}`;

let STYLEECTOR = {
  background(url) {
    return {
      backgroundImage: `url(${url})`,
      backgroundSize: `100% 100%`,
      backgroundPosition: `0px 0px`,
    };
  },
};

export default {
  name: "Disney",
  props: {
    info: {
      type: Object,
      required: true,
    },
    activityId: {
      type: String,
      required: true,
    },
    openId: {
      type: String,
      required: true,
    },
    activityStatus: {
      //活动状态 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
      type: Number,
      required: true,
    },
    enterSource: {
      // 进入来源
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      loadingStatus: 0, // 加载状态
      lotteryActivityId: "", // 抽奖活动id
      collectionActivityId: "", // 集卡活动id
      styleList: {}, // 样式
      gifList: {}, // 动画列表
      lotteryGif: [], // 动画列表
      remainingEnergy: 0, // 能量
      remainingOpportunities: "", //抽奖次数
      currentIndex: -1, // 九宫格格子
      count: 8, //共多少个位置
      timer: 0, //每次转动定时器
      speed: 200, //初始转动速度
      times: 0, // 转动次数
      cycle: 3, //转动基数：至少需要转动多少次再进入抽奖环节
      prizeColumn: 5, //中奖位置
      btnDisabled: false, // 禁用按钮
      prizeList: [], // 抽奖区域奖品列表
      isLottery: false, //是否在抽奖
      awardOption: {}, // 我的奖品配置
      gridOption: {}, // 九宫格配置
      ruleOption: {}, // 活动规则配置 三个tab 切换
      beFirst: false, //是否是第一次打开
      modalType: "", // 弹窗类型
      modalEvent: "", // 弹窗事件
      showMask: false, // 是否展示弹窗
      eleLoading: false, // 是否展示抽奖加载动画
      shareGuide: false, // 分享引导图
      cardList: [], // 集卡卡片列表
      collectBtnStyle: {}, // 防止极端情况
      winCardCount: 0, // 收集到卡片的数量
      exchangePrize: {}, // 要兑换的奖品
      isExchange: false, // 兑换卡片防抖
      remindWinCardList: [], // 提醒用户查看的卡片列表
      currentRemindItem: [], // 当亲提醒用户查看的卡片
      isReceiveCard: false, // 接收卡片防抖
      composeRecordList: [], // 组装的记录列表
      composeRecordStatus: false, // vue 框架fix
      collectRecordList: [], // 集卡记录列表
      lotteryRecordList: [], // 抽奖记录列表
      scrollTop: 0, // 滚动距离
      hasMore: true, // 是否有更多抽奖数据
      pageIndex: 1, // 分页页数
      pageSize: 5, // 分页条数
      lotteryPrize: {
        prizeType: 3,
      }, // 当前查看的抽奖奖品
      collectPrize: {}, // 当前查看的集卡奖品
      formList: [
        // 集卡奖品表单列表
        {
          paramName: "name",
          tips: "请填写收货人姓名",
        },
        {
          paramName: "phone",
          tips: "请填写收货人手机号",
        },
        {
          paramName: "address",
          tips: "请填写街道、楼牌号等",
        },
      ],
      submitInfo: {}, // 提交信息
      gif: "", //动画背景
      gifType: "", // 动画类型
      submitInfoBtnStatus: undefined, // 提交信息状态
      prizeFormItems: [], // 抽奖奖品表单列表
      userInfoBtnStatus: undefined, // 用户信息是否填写过
      submitBtn: "", // 未提交按钮
      submittedBtn: "", // 已提交按钮
      modelBgc: "", // 背景图
      userInfo: {
        //填表型填写的用户信息
        phone: "",
        name: "",
        address: "",
        remark: "",
        other: "",
      },
      prizeFontStyle: {}, // 奖品字体样式
      prizeBorderStyle: {}, // 奖品边框样式
      currentRule: 0, // 当前的活动规则
      redirectConfig: {}, // 跳转外部链接的配置
      lightIcon: "https://static.enmonster.com/1343844112822251520", // 白色icon
    };
  },
  computed: {
    exploreList() {
      // 探索更多列表
      let list = new Array(4).fill({});
      return list.map(
        (item, index) => this.styleList[`exploreItem${index + 1}`]
      );
    },
  },
  watch: {},
  mounted() {
    this.init();
  },

  methods: {
    init() {
      // init 函数

      this.formStyle(); // 初始化样式

      this.initLoadingAnimation(); // 初始化加载动画

      this.initPageData(); // 初始化页面数据
    },

    formStyle() {
      // 初始化样式

      this.styleList = {
        loadingBgImg: STYLEECTOR.background(`${requireImg("loading-bg.gif")}`),
        loadingBgLogo: `${requireImg("loading-bg-logo.png")}`,
        contentHeader: STYLEECTOR.background(`${requireImg("header.png")}`),
        lotteryHeader: STYLEECTOR.background(
          `${requireImg("lottery-header.png")}`
        ),
        lotteryContent: STYLEECTOR.background(
          `${requireImg("lottery-content.png")}`
        ),
        lotteryCenter: `${requireImg("lottery-center.gif")}`,
        lotteryPrizeOverviewBtn: STYLEECTOR.background(
          `${requireImg("lottery-prize-overview-btn.png")}`
        ),
        lotteryFooter: STYLEECTOR.background(
          `${requireImg("lottery-footer.png")}`
        ),
        lotteryBtn: STYLEECTOR.background(`${requireImg("lottery-btn.png")}`),
        shareBtn: STYLEECTOR.background(`${requireImg("share-btn.png")}`),
        collectContent: STYLEECTOR.background(
          `${requireImg("collect-content.png")}`
        ),
        recordContent: STYLEECTOR.background(`${requireImg("list-bg.png")}`),
        awardImg: `${requireImg("award-image.png")}`,
        exploreItem1: `${requireImg("explore-item1.png")}`,
        exploreItem2: `${requireImg("explore-item2.png")}`,
        exploreItem3: `${requireImg("explore-item3.png")}`,
        exploreItem4: `${requireImg("explore-item4.png")}`,
        exploreItemBtn: `${requireImg("explore-item-btn.png")}`,
        shareGuide: `${requireImg("share-guide.png")}`,
        activityRule: `${requireImg("activity-rule.png")}`,
        lotteryPrizeOverview: `${requireImg("lottery-prize-overview.png")}`,
        printsRuleOverview: `${requireImg("prints-rule.png")}`,

        collectModalBg: STYLEECTOR.background(
          `${requireImg("collect-modal-bg.png")}`
        ),
        useBattery: STYLEECTOR.background(`${requireImg("use-battery.png")}`),
        couponBtn: `${requireImg("coupon-btn.png")}`,
        closeBtn: `${requireImg("close-btn.png")}`,
        submitActive: `${requireImg("submit-active.png")}`,
        submitInactive: `${requireImg("submit-inactive.png")}`,
      };

      this.gifList = {
        A: `${requireImg("gif-A.gif")}`,
        B: `${requireImg("gif-B.gif")}`,
        C: `${requireImg("gif-C.gif")}`,
        D: `${requireImg("gif-D.gif")}`,
        E: `${requireImg("gif-E.gif")}`,
      };

      this.lotteryGif = [
        "B", // 1
        "C", // 2
        "A", // 3
        "E", // 4
        "D", // 5
        "D", // 6
        "E", // 7
      ];

      this.awardOption = this.info.props.imgList.awardOption; // 奖品列表配置
      this.gridOption = this.info.props.imgList.gridOption; // 抽奖格子配置
      this.ruleOption = this.info.props.imgList.ruleOption; // 活动规则配置
      this.swiperOption = this.info.props.imgList.swiperOption; // 轮播图配置

      this.modalType = "guide"; // 初始化的模态框 置为 引导
    },

    initLoadingAnimation() {
      let _loadingStatus = sessionStorage.getItem("_loadingStatus"); // 同一个 session内 加载动画只触发一次
      if (_loadingStatus) {
        this.loadingStatus = 1;
        return;
      }
      let timer = setTimeout(() => {
        this.loadingStatus = 1;
        sessionStorage.setItem("_loadingStatus", 1);
        clearTimeout(timer);
      }, 6300);
    },

    initPageData() {
      // 初始化页面数据

      this.getPageDetail(); // 获取页面数据详情

      this.getRedirectConfig(); // 获取重定向的配置

      this.getLotteryRecordList(); // 获取奖品的记录
    },

    getPageDetail() {
      // 获取页面详情
      let params = {
        activityId: this.activityId,
        openId: this.openId,
      };
      this.$fetch(
        {
          url: "/ehs/activity/user/disney/lottery/detail",
          method: "post",
        },
        params
      )
        .then((res) => {
          let cb = () => {
            if (res.success) {
              let { model } = res;
              this.lotteryActivityId = model.lotteryActivityId;
              this.remainingOpportunities = model.remainingOpportunities;
              this.remainingEnergy = model.remainingEnergy;
              // this.beFirst                = model.beFirst  // 本期活动不配置新用户引导图了
              this.prizeList = model.prizeList || [];
              this.collectionActivityId = model.collectionActivityId;
              this.cardList = model.cardList || [];
              this.exchangePrize = model.exchangePrize || {};
              this.collectRecordList =
                this.addRecordType(model.exchangeRecordList || [], "collect") ||
                [];
              this.remindWinCardList = model.remindWinCardList || []; // 提醒用户查看的 印记列表
              this.collectBtnStyle = this.getCollectBtnStyle();
              this.composeRecord();
              this.getWinCardCount();
              this.checkRemindCard();
            } else {
              this.toast(res.errorMessage);
            }
          };

          if (this.loadingStatus) {
            cb();
          } else {
            let timer = setInterval(() => {
              if (this.loadingStatus) {
                cb();
                clearInterval(timer);
              }
            }, 50);
          }
        })
        .catch((_) => {});
    },

    addRecordType(list, type) {
      // 增加奖品记录的类型
      if (!list || !Array.isArray(list) || !list.length) {
        return list;
      } else {
        return list.map((item) => Object.assign(item, { $recordType: type }));
      }
    },

    composeRecord() {
      // composeRecordList: [], // 集卡兑奖记录列表和 抽奖兑奖记录列表 合并的列表
      this.composeRecordStatus = false;
      let list = this.collectRecordList.concat(this.lotteryRecordList);
      this.$nextTick(() => {
        this.composeRecordStatus = true;
        this.composeRecordList = list;
        this.$nextTick(() => {
          if (this.$refs["content"]) {
            this.$refs["content"].scrollTop = `${this.scrollTop || 0.01}`;
          }
        });
      });
    },

    getCollectBtnStyle() {
      // 获取集卡按钮状态
      let styleMap = {
        active: STYLEECTOR.background(
          `${requireImg("collect-btn-active.png")}`
        ),
        inactive: STYLEECTOR.background(
          `${requireImg("collect-btn-inactive.png")}`
        ),
        lack: STYLEECTOR.background(`${requireImg("collect-btn-lack.png")}`),
        already: STYLEECTOR.background(
          `${requireImg("collect-btn-already.png")}`
        ),
      };
      let prize = this.exchangePrize;
      if (prize && prize.prizeId) {
        if (prize.canExchange) {
          return styleMap.active;
        } else {
          let { notExchangeCode } = prize;
          if (notExchangeCode) {
            if ("PRIZE_INVENTORY_ERROR" == notExchangeCode) {
              return styleMap.lack;
            } else if ("EXCHANGE_PERSONAL_LIMIT_ERROR" == notExchangeCode) {
              return styleMap.already;
            } else {
              return styleMap.inactive;
            }
          } else {
            return styleMap.inactive;
          }
        }
      } else {
        return styleMap.inactive;
      }
    },

    getRedirectConfig() {
      // 获取重定向的配置
      let params = {
        activityId: this.activityId,
        openId: this.openId,
      };
      this.$fetch(
        {
          url: "/ehs/load/config",
          method: "post",
        },
        params
      )
        .then((res) => {
          if (res.success) {
            let { model } = res;
            this.redirectConfig = model;
          }
        })
        .catch((_) => {});
    },

    getWinCardCount() {
      // 获取卡片数量
      let cardList = this.cardList;
      if (!cardList || (Array.isArray(cardList) && !cardList.length)) {
        this.winCardCount = 0;
      } else {
        let list = cardList.filter((item) => item.holdCount);
        this.winCardCount = (list && list.length) || 0;
      }
    },

    checkRemindCard() {
      // 检查提醒用户查看的卡片信息
      let activityStatus = this.activityStatus;
      if (activityStatus == 3) {
        let remindList = this.remindWinCardList;
        if (remindList.length) {
          this.currentRemindItem = remindList[0];
          this.modalType = "remindCard";
          this.showMask = true;
        }
      }
    },

    getLotteryRecordList() {
      // 获取抽奖得到的奖品记录列表
      let params = {
        openId: this.openId,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        activityId: this.activityId,
      };
      this.$fetch(
        { url: "/ehs/activity/user/win/prize/page", method: "post" },
        params
      )
        .then((res) => {
          if (res.success) {
            if (res.totalPage == this.pageIndex) {
              this.hasMore = false;
            } else {
              this.hasMore = true;
              this.pageIndex++;
            }
            this.lotteryRecordList = [
              ...this.lotteryRecordList,
              ...this.addRecordType(res.model, "lottery"),
            ];
            this.composeRecord();
          } else {
            this.toast(res.errorMessage);
          }
        })
        .catch((_) => {});
    },

    async startLottery() {
      // 点击抽奖
      let status = await this.activityStatusHooks();
      if (!status) {
        return;
      }
      if (this.btnDisabled) {
        return;
      }
      try {
        this.$log.senLog({
          pointID: "12020003",
          eventType: 2,
          businessData: {
            appSource: isMiniApplets() == "wechat" ? "WUC" : "ZUC",
          },
        });
      } catch (e) {}
      this.eleLoading = true;
      this.btnDisabled = true;
      this.handleLottery();
    },

    handleLottery() {
      // 操作抽奖
      let params = {
        activityId: this.activityId,
        openId: this.openId,
      };
      this.$fetch(
        {
          url: "/ehs/activity/user/lottery",
          method: "post",
        },
        params
      )
        .then((res) => {
          this.eleLoading = false;
          if (res.success) {
            this.prizeColumn = Number(res.model.prize.column); //获取奖品位置
            this.lotteryPrize = res.model.prize;
            this.speed = 120; //设置初始速度
            this.isLottery = true; //设置是否在抽奖状态
            this.currentIndex = -1; //设置抽奖开始位置
            this.startRoll();
          } else {
            this.btnDisabled = false;
            if (res.errorCode === "CLA100118") {
              this.modalType = "countError";
              this.showMask = true;
              return;
            } else if (res.errorCode === "CLA100007") {
              // 活动未开始
              this.toast(this.gridOption.actiUnstartTips);
              return;
            } else if (res.errorCode == "CLA100117") {
              // 活动已结束
              this.toast(this.gridOption.actiFinishedTips);
              return;
            }
            this.toast(res.errorMessage);
          }
        })
        .catch((_) => {
          this.eleLoading = false;
          this.btnDisabled = false;
          this.toast("当前网络不佳，请重试");
        });
    },

    // 开始转动
    startRoll() {
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法
      if (
        this.times > this.cycle + 10 &&
        this.prizeColumn == this.currentIndex
      ) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        this.times = 0;
        this.pageIndex = 1;
        this.lotteryRecordList = [];
        this.composeRecord();
        setTimeout(() => {
          this.isLottery = false;
          this.btnDisabled = false;
          this.initPageData();
          if (this.lotteryPrize.prizeType != 0) {
            this.getLotteryAddress(this.lotteryPrize, "new");
          } else {
            this.showMask = true;
            this.modelBgc = this.lotteryPrize.winPopupImage;
            this.modalType = "prize";
          }
        }, 500);
      } else {
        if (this.times < this.cycle) {
          this.speed -= 30; // 加快转动速度
        } else if (this.times === this.cycle) {
        } else if (
          this.times > this.cycle + 20 &&
          ((this.prizeColumn === 0 && this.currentIndex === 6) ||
            this.prizeColumn === this.currentIndex + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }

        if (this.speed < 30) {
          this.speed = 30;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },

    // 每一次转动
    oneRoll() {
      let index = this.currentIndex; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.currentIndex = index;
    },

    async shareActivity() {
      // 分享活动
      let status = await this.activityStatusHooks();
      if (!status) {
        return;
      }
      this.shareGuide = true;
      this.$log.senLog({
        pointID: "12020004",
        eventType: 2,
        businessData: {
          appSource: isMiniApplets() == "wechat" ? "WUC" : "ZUC",
        },
      });
    },

    hideShareGuide() {
      // 关闭分享指引
      this.shareGuide = false;
    },

    prizeGifLoad() {
      setTimeout(() => {
        this.modalType = "prize";
        setTimeout(() => {
          this.gifType = "";
          this.modalEvent = "";
        }, 500);
      }, 2500);
    },

    awardGifLoad() {
      setTimeout(() => {
        this.modalType = "award";
        setTimeout(() => {
          this.gifType = "";
          this.modalEvent = "";
        }, 500);
      }, 2500);
    },

    async exchangeCollectPrize() {
      // 兑换集卡奖品
      let status = await this.activityStatusHooks();
      if (!status) {
        return;
      }
      let activityStatus = this.activityStatus; // 这里的判断重复了 不过无所谓了
      if (activityStatus !== 3) {
        return;
      }
      if (this.isExchange) {
        return;
      }
      this.isExchange = true;
      try {
        this.$log.senLog({
          pointID: "12020005",
          eventType: 2,
          businessData: {
            appSource: isMiniApplets() == "wechat" ? "WUC" : "ZUC",
          },
        });
      } catch (e) {}
      const exchangePrize = this.exchangePrize || {};
      if (exchangePrize.canExchange) {
        // 能兑换弹出兑奖
        this.submitExchangePrize(); // 提交兑换奖品
      } else {
        this.isExchange = false;
        let { notExchangeCode, notExchangeReason } = exchangePrize;
        if (notExchangeCode) {
          if (notExchangeCode == "EXCHANGE_DEDUCTION_ERROR") {
            // 获得的卡片数量不够
            this.toast("集齐全部「为伍印记」才可兑换哦~");
          } else if (notExchangeCode == "PRIZE_INVENTORY_ERROR") {
            this.toast("奖品抢光了，快去参与其他活动吧～");
          } else if (notExchangeCode == "EXCHANGE_PERSONAL_LIMIT_ERROR") {
            this.toast("已兑换成功1次");
          } else {
            notExchangeReason && this.toast(notExchangeReason);
          }
        }
      }
    },

    submitExchangePrize() {
      // 提交兑换奖品
      let cardIdList = this.cardList
        .filter((item) => item.holdCount)
        .map((item) => item.cardId);
      let params = {
        activityId: this.collectionActivityId,
        openId: this.openId,
        exchangePrizeId: this.exchangePrize.prizeId,
        cardIdList,
      };
      this.$fetch(
        {
          url: "/ehs/king/exchange",
          method: "post",
        },
        params
      )
        .then((res) => {
          this.isExchange = false;
          if (res.success) {
            const { model } = res;
            if (model.exchangeResult) {
              let exchangeRecord = { id: model.id };
              this.getCollectAddress(exchangeRecord, "new");
              this.showMask = true;
              this.gifType = "awardGif";
              this.modalEvent = "gif";
              this.gif = this.gifList["A"];
            } else {
              let { errorCode, errorMessage } = model;
              if (errorCode == "PRIZE_INVENTORY_ERROR") {
                this.toast("奖品抢光了，快去参与其他活动吧～");
              } else {
                this.toast(errorMessage || "当前网络不佳，请稍后重试~");
              }
            }
          } else {
            this.toast(
              res.errorMessage ||
                res.model.errorMessage ||
                "当前网络不佳，请稍后重试~"
            );
          }
          setTimeout(() => {
            this.pageIndex = 1;
            this.lotteryRecordList = [];
            this.composeRecord();
            this.initPageData();
          }, 1500);
        })
        .catch((_) => {
          this.isExchange = false;
          this.toast("当前网络不佳，请稍后重试~");
          this.pageIndex = 1;
          this.lotteryRecordList = [];
          this.composeRecord();
          this.initPageData();
        });
    },

    closeDialog() {
      // 关闭弹出层 是否有其他逻辑需要补充的？ 待定 其他初始化 状态 置为 初始化
      this.prizeFontStyle = {};
      this.prizeBorderStyle = {};
      this.showMask = false;
      if (this.modalType == "remindCard") {
        this.receiveCollectionCard("auto");
      }
      this.modalType = "";
      this.gif = "";
      this.modalEvent = "";
      this.currentIndex = -1;
    },

    async handlePopup(type) {
      // 展示弹窗点击
      let status = await this.activityStatusHooks();
      if (!status) {
        return;
      }
      if (type == "activityRule") {
        this.showMask = true;
        this.modalType = "activityRule";
      } else if (type == "lotteryPrizeOverview") {
        this.showMask = true;
        this.modalType = "lotteryPrizeOverview";
        this.$log.senLog({
          pointID: "12020002",
          eventType: 2,
          businessData: {
            appSource: isMiniApplets() == "wechat" ? "WUC" : "ZUC",
          },
        });
      } else if (type == "printsRuleOverview") {
        this.showMask = true;
        this.modalType = "printsRuleOverview";
      }
    },

    async changeRule(index) {
      // 切换规则图片
      let status = await this.activityStatusHooks();
      if (!status) {
        return;
      }
      this.currentRule = index;
    },

    async handleClick(type) {
      // 处理点击事件
      if (type == "rule") {
        // 活动规则
        let status = await this.activityStatusHooks();
        if (!status) {
          return;
        }
        this.$log.senLog({
          pointID: "12020006",
          eventType: 2,
          businessData: {
            appSource: isMiniApplets() == "wechat" ? "WUC" : "ZUC",
          },
        });
        setTimeout(() => {
          this.$emit("handleGridClick", this.ruleOption);
        }, 1000);
      } else if (type == "countError") {
        // 抽奖次数不足
        let clickConfig = {
          jumpType: 3,
          wxPath: "/Pages/index",
          aliPath: "/pages/index/index",
        };
        this.$emit("handleGridClick", clickConfig);
      } else if (type == "prize") {
        // 奖品
        let { prizeType } = this.lotteryPrize;
        if (prizeType == 4) {
          // 告知型奖品
          if (this.clickForwardConfig.jumpType == 6) {
            this.copyMsg(this.clickForwardConfig.urlPath);
          } else {
            this.$emit("handleGridClick", this.clickForwardConfig);
          }
        } else if (prizeType == 1) {
          // 怪兽充电券
          let clickConfig = {
            jumpType: 3,
            wxPath: "/Pages/index",
            aliPath: "/pages/index/index",
          };
          this.$emit("handleGridClick", clickConfig);
        } else if (prizeType == 0) {
          // 关闭弹窗
          this.closeDialog();
        }
      } else if (type == "redirect") {
        // 探索更多
        let status = await this.activityStatusHooks();
        if (!status) {
          return;
        }
        this.$log.senLog({
          pointID: "12020007",
          eventType: 2,
          businessData: {
            appSource: isMiniApplets() == "wechat" ? "WUC" : "ZUC",
          },
        });
        let redirectOption = {
          // 模拟配置项
          jumpType: 4,
          AliURL: this.redirectConfig.h5WebSiteUrl, // h5网站链接
          wxURL: this.redirectConfig.publicWebUrl, // 公众号地址
        };
        setTimeout(() => {
          // 防止打点遗漏
          this.$emit("handleGridClick", redirectOption);
        }, 1000);
      }
    },

    receiveCollectionCard() {
      // 领取获取到的卡片
      if (this.isReceiveCard) {
        return;
      }
      this.isReceiveCard = true;
      let item = this.currentRemindItem;

      let params = {
        activityId: this.collectionActivityId,
        openId: this.openId,
        winRecordIdList: [item.winRecordId || ""],
      };
      this.$fetch(
        {
          url: "/ehs/activity/user/receive/collection/card",
          method: "post",
        },
        params
      )
        .then((_) => {
          this.showMask = false;
          this.modalType = "";
          setTimeout(() => {
            this.isReceiveCard = false;
            this.getPageDetail();
          }, 800);
        })
        .catch((_) => {
          this.showMask = false;
          this.modalType = "";
          setTimeout(() => {
            this.isReceiveCard = false;
            this.getPageDetail();
          }, 800);
        });
    },

    handleCopy() {
      // 复制兑换码
      if (this.lotteryPrize.prizeType == 2) {
        this.copyMsg(this.ticketCode);
      }
    },

    copyMsg(msg) {
      // 复制文字
      this.$copyText(msg).then(
        (e) => {
          this.toast("复制成功");
        },
        (err) => {
          this.toast("复制出错");
        }
      );
    },

    addLotteryAddress() {
      // 添加收货地址
      for (let i = 0; i < this.prizeFormItems.length; i++) {
        let item = this.prizeFormItems[i];
        switch (item.paramName) {
          case "name":
            if (!this.trim(this.userInfo.name)) {
              this.toast("请填写姓名");
              return;
            }
            break;
          case "phone":
            if (!this.trim(this.userInfo.phone)) {
              this.toast("请填写手机号");
              return;
            } else if (!/1\d{10}/.test(this.userInfo.phone)) {
              this.toast("手机号格式不正确，请重新填写");
              return;
            }
            break;
          case "address":
            if (!this.trim(this.userInfo.address)) {
              this.toast("请填写地址");
              return;
            } else if (this.trim(this.userInfo.address).length < 10) {
              this.toast("地址文字过短，请重新填写");
              return;
            } else if (this.trim(this.userInfo.address).length > 300) {
              this.toast("地址文字过长，请重新填写");
              return;
            }
            break;
          case "remark":
            if (!this.trim(this.userInfo.remark)) {
              this.toast("【备注】不能为空。");
              return;
            }
            break;
          case "other":
            if (!this.trim(this.userInfo.other)) {
              this.toast("【其他】不能为空。");
              return;
            }
            break;
        }
      }

      let params = {
        activityId: this.activityId,
        openId: this.openId,
        recordId: this.lotteryPrize.recordId,
        ...this.userInfo,
      };
      this.$fetch(
        { url: "/ehs/activity/user/address/add", method: "post" },
        params
      ).then((res) => {
        if (res.success) {
          this.showMask = false;
          this.toast("提交成功");
        } else {
          this.toast(res.errorMessage);
        }
      });
    },

    addCollectAddress() {
      // 添加集卡地址
      for (let i = 0; i < this.formList.length; i++) {
        let item = this.formList[i];
        switch (item.paramName) {
          case "name":
            if (!this.trim(this.submitInfo.name)) {
              this.toast("请填写姓名");
              return;
            }
            break;
          case "phone":
            if (!this.trim(this.submitInfo.phone)) {
              this.toast("请填写手机号");
              return;
            } else if (!/1\d{10}/.test(this.submitInfo.phone)) {
              this.toast("手机号格式不正确，请重新填写");
              return;
            }
            break;
          case "address":
            if (!this.trim(this.submitInfo.address)) {
              this.toast("请填写地址");
              return;
            } else if (this.trim(this.submitInfo.address).length < 10) {
              this.toast("地址文字过短，请重新填写");
              return;
            } else if (this.trim(this.submitInfo.address).length > 300) {
              this.toast("地址文字过长，请重新填写");
              return;
            }
            break;
          case "remark":
            if (!this.trim(this.submitInfo.remark)) {
              this.toast("【备注】不能为空。");
              return;
            }
            break;
          case "other":
            if (!this.trim(this.submitInfo.other)) {
              this.toast("【其他】不能为空。");
              return;
            }
            break;
        }
      }

      let params = {
        activityId: this.collectionActivityId,
        openId: this.openId,
        recordId: this.collectPrize.id,
      };

      let addParams = (val) => {
        let addressParamList = ["phone", "name", "address", "remark", "other"];
        let addtion = {};
        for (let item of addressParamList) {
          if (val.hasOwnProperty(item) && val[item]) {
            addtion[item] = val[item];
          }
        }
        return addtion;
      };
      params = Object.assign(params, addParams(this.submitInfo));
      this.$fetch({ url: "/ehs/king/address/add/v2", method: "post" }, params)
        .then((res) => {
          if (res.success) {
            this.showMask = false;
            this.toast("提交成功");
          } else {
            this.toast(res.errorMessage);
          }
        })
        .catch((_) => {});
    },

    handleRecordScroll() {
      // 奖品记录滑动
      let scrollTop = this.$refs["content"].scrollTop;
      let clientHeight = this.$refs["content"].clientHeight;
      let scrollHeight = this.$refs["content"].scrollHeight;
      this.scrollTop = scrollTop.toFixed(4) || 0.01;
      if (scrollTop + clientHeight + 100 >= scrollHeight && this.hasMore) {
        this.hasMore = false;
        this.throttle(this.getLotteryRecordList, 2000)();
      }
    },

    throttle(fn, interval = 500) {
      // 节流器
      let timer = null;
      let firstTime = true;
      return function () {
        let args = arguments;
        if (firstTime) {
          // 第一次加载
          fn.apply(this, args);
          return (firstTime = false);
        }
        if (timer) {
          // 定时器正在执行中，跳过
          return;
        }
        timer = setTimeout(() => {
          // clearTimeout(timer);
          timer = null;
          fn.apply(this, args);
        }, interval);
      };
    },

    async checkPrize(item) {
      // 查看奖品 不受活动状态限制
      if (item && item.$recordType) {
        let { $recordType } = item;
        if ($recordType === "lottery") {
          if (item.prizeType != 3) {
            this.lotteryPrize = item;
            this.getLotteryAddress(item, "view");
            this.modalType = "prize";
          } else {
            if (item.status) {
              this.lotteryPrize = item;
              this.getLotteryAddress(item, "view");
              this.modalType = "prize";
            } else {
              if (!item.canFill) {
                this.toast(item.cannotFillTip || "奖品兑换已结束");
              } else {
                this.lotteryPrize = item;
                this.getLotteryAddress(item, "view");
                this.modalType = "prize";
              }
            }
          }
        } else if ($recordType === "collect") {
          if (item.status) {
            this.getCollectAddress(item, "view");
            this.modalType = "award";
            this.collectPrize = item;
          } else {
            if (!item.canFill) {
              this.toast(item.cannotFillTip || "奖品兑换已结束");
            } else {
              this.getCollectAddress(item, "view");
              this.modalType = "award";
              this.collectPrize = item;
            }
          }
        }
      }
    },

    getLotteryAddress(item, type) {
      // 获取奖品收货地址等信息 type -> new 首次 view 查看
      let params = {
        activityId: this.activityId,
        openId: this.openId,
        recordId: item.recordId,
      };
      this.$fetch(
        { url: "/ehs/activity/user/address/getAddress", method: "post" },
        params
      ).then((res) => {
        if (res.success) {
          let result = res.model;
          if (result.entityPrizeFormConfig) {
            this.prizeFormItems =
              result.entityPrizeFormConfig.prizeFormItems || [];
            this.submitBtn = result.entityPrizeFormConfig.submitBtn;
            this.submittedBtn = result.entityPrizeFormConfig.submittedBtn;
          }
          this.userInfoBtnStatus = result.status;
          this.modelBgc = result.winPopupImage;
          this.showMask = true;
          if (type == "new") {
            this.gifType = "prizeGif";
            this.modalEvent = "gif";
            this.gif = this.gifList[this.lotteryGif[Number(this.prizeColumn)]];
          } else if (type == "view") {
            this.modalType = "prize";
          }
          if (result.prizeType == 3) {
            // 表单类奖品
            let titleInputBoxCssConfig =
              result.entityPrizeFormConfig.titleInputBoxCssConfig;
            this.userInfo = {
              name: res.model.name,
              phone: res.model.phone,
              address: res.model.address,
              remark: res.model.remark,
              other: res.model.other,
            };
            this.prizeFontStyle = {
              "font-size": `${titleInputBoxCssConfig.size / 2}px`,
              color: titleInputBoxCssConfig.color,
              "font-style": titleInputBoxCssConfig.style.includes("italic")
                ? "italic"
                : "",
              "font-weight": titleInputBoxCssConfig.style.includes("bold")
                ? "bold"
                : "",
            };
            this.prizeBorderStyle = {
              ...this.prizeFontStyle,
              "border-color": titleInputBoxCssConfig.color,
            };
          } else if (result.prizeType == 2) {
            // 第三方券码
            this.ticketCode = result.prizeCode;
            let couponCssConfig = result.couponCssConfig;
            this.prizeFontStyle = {
              "font-size": `${couponCssConfig.size / 2}px`,
              color: couponCssConfig.color,
              "font-style": couponCssConfig.style.includes("italic")
                ? "italic"
                : "",
              "font-weight": couponCssConfig.style.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${couponCssConfig.outline}`,
            };
          } else if (result.prizeType == 4) {
            // 告知类奖品
            if (result.clickForwardConfig.beCommonClickForward) {
              // 不区分平台统一配置
              this.clickForwardConfig = result.clickForwardConfig;
            } else {
              let isMiniApp = isMiniApplets();
              if (
                result.clickForwardConfig &&
                result.clickForwardConfig.diffPlatformClickForwardConfig &&
                Array.isArray(
                  result.clickForwardConfig.diffPlatformClickForwardConfig
                ) &&
                result.clickForwardConfig.diffPlatformClickForwardConfig.length
              ) {
                result.clickForwardConfig.diffPlatformClickForwardConfig.forEach(
                  (item) => {
                    if (isMiniApp === "wechat" && item.platform == 1) {
                      this.clickForwardConfig = item;
                    } else if (isMiniApp === "alipay" && item.platform == 0) {
                      this.clickForwardConfig = item;
                    } else if (isMiniApp === "eleme" && item.platform == 2) {
                      this.clickForwardConfig = item;
                    }
                  }
                );
              }
            }
          }
        } else {
          this.toast(res.errorMessage);
        }
      });
    },

    getCollectAddress(item, type) {
      // 获取集卡的地址信息 type -> new 首次 view 查看
      if (item && item.id) {
        let params = {
          openId: this.openId,
          activityId: this.collectionActivityId,
          recordId: item.id,
        };
        this.$fetch(
          {
            url: "/ehs/king/address/detail",
            method: "post",
          },
          params
        )
          .then((res) => {
            if (type !== "new") {
              this.showMask = true;
            }
            if (res.success) {
              let { model } = res;
              let mappingRule = {
                addressee: "name",
                mobile: "phone",
                address: "address",
                remark: "remark",
                other: "other",
              };
              let info = {};
              for (let key in model) {
                if (mappingRule.hasOwnProperty(key)) {
                  info[mappingRule[key]] = model[key];
                }
              }
              this.submitInfo = info;
              this.submitInfoBtnStatus = model.status;
            } else {
              this.submitInfo = {
                name: "",
                phone: "",
                address: "",
              };
              this.submitInfoBtnStatus = 0;
            }
          })
          .catch((_) => {
            this.submitInfo = {
              name: "",
              phone: "",
              address: "",
            };
            this.showMask = true;
            this.submitInfoBtnStatus = 0;
          });
      }
    },

    toast(txt) {
      // 报错提示
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff",
        },
        content: txt,
        duration: 2000,
      }).then(() => {
        console.log("finish");
      });
    },

    activityStatusHooks() {
      // 活动状态钩子
      return new Promise((resolve, reject) => {
        if (this.activityStatus == 3) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.disney {
  width: 100%;
  font-size: 24px;
  font-family: sans-serif;
}

.loading-page {
  width: 100%;
  height: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;

  .loading-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    z-index: 2;
    background-size: 100% 1624px !important;

    .loading-logo {
      width: 230px;
      display: block;
      position: absolute;
      left: 50%;
      bottom: 7%;
      transform: translateX(-50%);
    }
  }
}

.content-page {
  width: 100%;

  .content-header {
    height: 522px;

    .view-rule-btn {
      width: 100px;
      height: 100px;
    }
  }

  .lottery-area {
    .lottery-header {
      height: 132px;
      color: #2a0162;
      font-size: 32px;
      font-weight: 800;
      line-height: 132px;
      text-align: center;

      .header-content {
        width: 100%;
        height: 100%;

        &.content-on {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        }
      }

      .header-desc {
        color: #2a0162;
        font-size: 32px;
        font-weight: 800;
        line-height: 132px;
      }

      .remaining-energy {
        position: relative;
        margin: 0 14px;
        padding: 0 12px;
        height: 48px;
        line-height: 48px;
        background: linear-gradient(138deg, #340475 0%, #3e1563 100%);
        border-radius: 12px;
        color: #fff0cf;
        font-size: 34px;
        font-weight: bold;

        .decorate {
          position: absolute;
          top: 4px;
          left: 4px;
          border-radius: 8px;
          border: 2px solid;
          border-image: linear-gradient(
              125deg,
              rgba(255, 240, 208, 1),
              rgba(251, 249, 224, 1)
            )
            2px 2px;
          width: calc(100% - 8px);
          height: calc(100% - 8px);
        }
      }
    }

    .lottery-content {
      position: relative;
      height: 682px;
      z-index: 2;

      .lottery-list {
        position: absolute;
        width: 512px;
        height: 512px;
        border-radius: 98px;
        left: 50%;
        transform: translateX(-50%);
        top: 86px;
        overflow: hidden;

        .img {
          position: absolute;
        }

        .img1 {
          width: 222px;
          height: 204px;
          top: 0px;
          left: 33px;
        }

        .img2 {
          width: 224px;
          height: 206px;
          top: 0px;
          right: 31px;
        }

        .img3 {
          width: 204px;
          height: 222px;
          right: 4px;
          top: 32px;
        }

        .img4 {
          width: 204px;
          height: 222px;
          right: 2px;
          bottom: 34px;
        }

        .img5 {
          width: 224px;
          height: 206px;
          bottom: 3px;
          right: 32px;
        }

        .img6 {
          width: 226px;
          height: 204px;
          bottom: 3px;
          left: 31px;
        }

        .img7 {
          width: 204px;
          height: 224px;
          left: 2px;
          bottom: 33px;
        }

        .img8 {
          width: 206px;
          height: 222px;
          left: 2px;
          top: 31px;
        }
      }

      .lottery-pirze-overview {
        width: 100px;
        height: 80px;
        position: absolute;
        left: 50%;
        bottom: -25px;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        align-items: center;

        .btn {
          width: 74px;
          height: 50px;
        }
      }

      .lottery-center {
        width: 180px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 5;
      }
    }

    .lottery-footer {
      position: relative;
      height: 274px;

      .lottery-btn,
      .share-btn {
        position: absolute;
        top: 44px;
        width: 322px;
        height: 134px;
      }

      .lottery-btn {
        // top 方向的尺寸和高度可能需要微调
        left: 42px;

        .btn {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .share-btn {
        // top 方向的尺寸和高度可能需要微调
        right: 42px;
      }
    }
  }

  .collect-area {
    .collect-content {
      height: 958px;
      position: relative;

      .list {
        position: absolute;
        display: flex;
        left: 50px;
        bottom: 318px;

        .item {
          width: 80px;
          height: 80px;
          margin-right: 12px;

          .item-img {
            display: block;
            width: 80px;
          }
        }
      }

      .count {
        position: absolute;
        right: 282px;
        bottom: 266px;
        color: #5322c1;
        text-align: center;
        font-size: 26px;
        font-weight: bold;
        width: 32px;
        height: 32px;
        line-height: 32px;
        background: linear-gradient(142deg, #f3d595 0%, #fffdeb 100%);
        border-radius: 8px;
      }

      .prints-rule-overview {
        position: absolute;
        bottom: 260px;
        left: 0;
        width: 100%;
        height: 150px;
      }

      .collect-btn {
        position: absolute;
        width: 670px;
        height: 92px;
        bottom: 72px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .explore-area {
    .explore-item {
      width: 100%;

      &.explore-item-btn {
        position: relative;

        .btn {
          position: absolute;
          width: 674px;
          height: 92px;
          top: 22px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .explore-item-img {
      display: block;
      width: 100%;
    }
  }
}

@keyframes fadeIn {
  0% {
    transform: scale(0.7);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.award-wrap {
  width: 618px;
  height: 780px;
  position: relative;

  &.award-wrap-ab {
    width: 618px;
    height: 780px;
    position: absolute;
    z-index: 5;
    animation: fadeIn 500ms ease-in;
    top: 0;
    left: 0;
  }

  .form-list {
    padding: 0 40px;
    position: absolute;
    bottom: 200px;
    box-sizing: border-box;
    width: 100%;
    box-sizing: border-box;

    .form-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
        align-items: flex-start;
      }
    }

    .form-label {
      font-size: 22px !important;
      color: #fff !important;
      width: auto;
    }

    .label-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-basis: 180px;
    }

    .form-textarea,
    .form-input {
      flex-basis: 500px;
      box-sizing: border-box;
      padding: 8px 15px;
      border-radius: 0;
      background: none;
      color: #fff !important;
      font-size: 26px !important;
    }

    .form-input {
      border-bottom: 2px dotted #fff !important;
    }

    .form-textarea {
      height: 98px;
      border: 2px dotted #fff !important;
    }
  }

  .form-icon {
    display: block;
    width: 12px;
    height: 20px;
    margin-right: 6px;
  }

  .address-label {
    padding-top: 10px;
    display: flex;
    flex-direction: row;

    .form-icon {
      margin-top: 8px;
    }
  }

  .btn {
    width: 472px;
    height: 112px;
    display: block;
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
  }

  input::placeholder,
  textarea::placeholder {
    color: #f9eeb9 !important;
    font-size: 26px !important;
    font-weight: 400 !important;
  }
}

.award-gif-wrap {
  width: 618px;
  height: 780px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  .gif {
    width: 100%;
    display: block;
  }
}

.prize-gif-wrap {
  width: 618px;
  height: 780px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  .gif {
    width: 100%;
    display: block;
  }
}

.prize-wrap {
  width: 618px;
  height: 780px;
  background-size: 100% 100% !important;
  position: relative;

  &.prize-wrap-ab {
    width: 618px;
    height: 780px;
    position: absolute;
    z-index: 5;
    animation: fadeIn 500ms ease-in;
    top: 0;
    left: 0;
  }

  .ticket-code {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 200px;
  }

  .form {
    padding: 0 40px;
    position: absolute;
    bottom: 200px;
    box-sizing: border-box;
    width: 100%;
    box-sizing: border-box;

    .form-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
        align-items: flex-start;
      }
    }

    .form-label {
      font-size: 22px !important;
      color: #fff !important;
      width: auto;
    }

    .label-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-basis: 180px;
    }

    .form-textarea,
    .form-input {
      flex-basis: 500px;
      box-sizing: border-box;
      padding: 8px 15px;
      border-radius: 0;
      background: none;
      color: #fff !important;
      font-size: 26px !important;
    }

    .form-input {
      border-bottom: 2px dotted #fff !important;
    }

    .form-textarea {
      height: 98px;
      border: 2px dotted #fff !important;
    }
  }

  .form-icon {
    display: block;
    width: 12px;
    height: 20px;
    margin-right: 6px;
  }

  .address-label {
    padding-top: 10px;
    display: flex;
    flex-direction: row;

    .form-icon {
      margin-top: 8px;
    }
  }

  .btn {
    width: 472px;
    height: 112px;
    display: block;
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
  }

  .prize-area {
    width: 100%;
    height: 100%;
  }

  input::placeholder,
  textarea::placeholder {
    color: #f9eeb9 !important;
    font-size: 26px !important;
    font-weight: 400 !important;
  }
}

.rule-wrap {
  .header,
  .footer {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    height: 480px;
    position: relative;

    .hot-area {
      width: 660px;
      height: 220px;
      position: absolute;
      left: 50%;
      display: flex;
      transform: translateX(-50%);

      .item0 {
        flex: 220px;
      }

      .item1 {
        flex: 170px;
      }

      .item2 {
        flex: 165px;
      }
    }
  }

  img {
    height: 100%;
  }
}

.content-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.content-wrap-ab {
    position: absolute;
    width: 618px;
    height: 932px;
  }
}

.activity-rule-wrap {
  width: 618px;

  img {
    width: 100%;
  }
}

.lottery-prize-overview-wrap {
  width: 618px;

  img {
    width: 100%;
  }
}

.prints-rule-wrap {
  width: 618px;

  img {
    width: 100%;
  }
}

.countError-wrap {
  width: 618px;
  height: 780px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .btn {
    position: absolute;
    width: 472px;
    height: 112px;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.line {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .dotted-line {
    display: block;
    width: 4px;
    height: 8px;
    background: #fff;
    margin-top: 4px;
  }

  .close-icon {
    width: 68px;
    height: 68px;
  }
}

.line-space {
  width: 1px;
  height: 152px;
  background-color: rgba(255, 255, 255, 0.01);
}

.share-guide {
  width: 100vw;
  height: 100vh;
  position: relative;

  .share-guide-img {
    width: 100%;
    position: absolute;
    display: block;
    left: 0;
    top: 0;
  }
}

.eleLoadingContent {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .eleLoading {
    width: 132px;
    height: 132px;
  }
}

.remind-wrap {
  width: 618px;
  height: 780px;
  position: relative;

  img {
    display: block;
    width: 100%;
  }

  .btn {
    position: absolute;
    width: 500px;
    height: 120px;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.reward-wrap {
  // 奖品列表区域
  box-sizing: border-box;

  .header {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .active {
    max-height: 765px;
    overflow-y: auto;
    transition: height ease-in 0.5s;
  }

  .content {
    img {
      width: 100%;
      display: block;
    }

    background-size: 100% 70px !important;
    background-repeat: repeat !important;
  }

  .footer {
    width: 100%;

    img {
      width: 100%;
    }
  }
}
</style>